import { render, staticRenderFns } from "./PanelRightNotification.vue?vue&type=template&id=4ce5449c&"
import script from "./PanelRightNotification.vue?vue&type=script&lang=js&"
export * from "./PanelRightNotification.vue?vue&type=script&lang=js&"
import style0 from "./PanelRightNotification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports